import {
  Android,
  Aparat,
  Bazaar,
  GoogleStore,
  Instagram,
  Mayket,
  Telegram,
  Twiter,
  Youtube
} from '../svgs';
import { AppRowType, ColumnType, SocialType } from '../types/types';

export const Columns: ColumnType[] = [
  {
    title: 'رابکس',
    shortTitle: 'رابکس',
    descriptions: [
      { desc: 'درباره رابکس', link: '/about' },
      { desc: 'تماس با ما', link: '/contact' },
      { desc: 'فرصت‌های شغلی', link: 'https://careers.rabex.ir/' },
      {
        desc: 'قوانین و مقررات',
        link: 'https://rabex.ir/terms/'
      },
      {
        desc: ' سیاست حریم شخصی',
        link: 'https://rabex.ir/policy/'
      }
    ]
  },

  {
    title: 'آکادمی، آموزش ارز دیجیتال',
    shortTitle: ' آکادمی رابکس',
    descriptions: [
      {
        desc: 'آموزش ارز دیجیتال',
        link: 'https://rabex.ir/academy/'
      },
      {
        desc: 'اخبار ارز دیجیتال',
        link: 'https://rabex.ir/news/'
      },
      {
        desc: 'ارز دیجیتال چیست',
        link: 'https://rabex.ir/academy/articles/what-is-digital-currency/'
      },
      {
        desc: 'بلاک چین چیست',
        link: 'https://rabex.ir/academy/articles/what-is-blockchain/'
      },
      {
        desc: 'آموزش ترید',
        link: 'https://rabex.ir/academy/articles/what-is-trade/'
      },
      {
        desc: 'آموزش کیف پول',
        link: 'https://rabex.ir/academy/articles/what-is-crypto-wallet/'
      }
    ]
  },
  {
    title: 'خرید و فروش ارز دیجیتال',
    shortTitle: 'خرید و فروش',
    descriptions: [
      { desc: 'خرید ارز دیجیتال', link: '/' },
      { desc: 'خرید تتر', link: '/price/usdt' },
      { desc: 'خرید بیت‌کوین', link: '/price/btc' },
      { desc: 'خرید اتریوم', link: '/price/eth' },
      { desc: 'خرید دوج کوین', link: '/price/doge' },
      { desc: 'خرید ترون', link: '/price/trx  ' }
    ]
  },
  {
    title: 'راهنما',
    shortTitle: 'راهنما',
    descriptions: [
      { desc: 'راهنمای پلتفرم', link: 'https://rabex.ir/help/' },
      { desc: 'پرسش‌های متداول', link: 'https://rabex.ir/faq/' },
      {
        desc: 'درآمدزایی در رابکس',
        link: 'https://rabex.ir/earn/'
      },
      { desc: 'کارمزد معاملات', link: 'https://rabex.ir/fee/' },
      { desc: 'قیمت ارزهای دیجیتال', link: 'https://rabex.ir/price' }
    ]
  }
];

export const SocialRow: SocialType[] = [
  { link: 'https://www.instagram.com/rabex.ir/', icon: <Instagram /> },
  { link: 'https://t.me/Rabexio', icon: <Telegram /> },
  { link: 'https://x.com/SolareumChain', icon: <Twiter /> },
  {
    link: 'https://www.youtube.com/@rabex_ir',
    icon: <Youtube />
  },
  {
    link: 'https://www.aparat.com/rabex',
    icon: <Aparat />
  }
];

export const AppRow: AppRowType[] = [
  { link: 'https://rabex.ir/downloads/rabex.apk', icon: <Android /> },
  { link: 'https://cafebazaar.ir/app/com.rabin.rabex', icon: <Bazaar /> },
  { link: 'https://myket.ir/app/com.rabin.rabex', icon: <Mayket /> },
  {
    link: 'https://play.google.com/store/apps/details?id=com.rabin.rabex',
    icon: <GoogleStore />
  }
];
